export const ActiveSlotCSSClass = 'active-slot';
export const SingleActiveSlotCSSClass = 'single-active-slot';
export const ActiveCreateEvent = 'active-create-event';
export const PlannerEventHovered = 'planner-event-hovered';
export const ActiveDragOrResizeEvent = 'active-drag-or-resize-event';
export const ActiveDragOrResizeGrid = 'active-drag-or-resize-grid';
export const SelectedLeftPlannerEvent = 'selected-left-event';
export const SelectedRightPlannerEvent = 'selected-right-event';
export const ResizeHandlePlannerEvent = 'resize-handle';
export const LeftHandlePlannerEvent = 'left-handle';
export const AbsencePlannerEventCSSClass = 'planner-event-item';
export const LockedMemberCellCSSClass = 'locked-member-cell';

export const AbsencePlannerFixedColumnWidth = 200;
